import InspectionDefects from "./InspectionDefects";

export default InspectionDefects;